module.exports = __webpack_public_path__ + "media/universities/CentraleSupélec-f181fdf2.png";